import "@/index.css";
import i18n from "@/i18n.ts";
import { queryClient } from "@/queryClient.ts";
import { router } from "@/routes/router.tsx";
import { AppProvider } from "@/themes/provider.tsx";
import "allotment/dist/style.css";
import { beforeSend } from "@/sentry/before-send.ts";
import { installDomPatch } from "@/sentry/dom-patch.ts";
import { AppDistribution } from "@/types/common.types.ts";
import * as Sentry from "@sentry/react";
import "./i18n";
import { pdfRuntime } from "@/components/document-viewer/pdf-runtime.ts";
import { PdfRuntimeProvider, TranslationProvider } from "@skailer-com/uikit";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";

if (
  import.meta.env.VITE_APP_DISTRIBUTION == AppDistribution.skailer ||
  import.meta.env.VITE_APP_DISTRIBUTION == AppDistribution.headly
) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_URL,
    environment: import.meta.env.VITE_APP_ENVIRONMENT,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    release: import.meta.env.VITE_APP_VERSION,
    tracesSampleRate: 0.05,
    beforeSend,
  });
}

installDomPatch();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <AppProvider>
    <QueryClientProvider client={queryClient}>
      <TranslationProvider t={i18n.t}>
        <PdfRuntimeProvider runtime={pdfRuntime}>
          <RouterProvider router={router} />
          <ReactQueryDevtools initialIsOpen={false} />
        </PdfRuntimeProvider>
      </TranslationProvider>
    </QueryClientProvider>
  </AppProvider>
);
